/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SelectRestaurantRouteImport } from './routes/select-restaurant'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthAnalyticsRouteImport } from './routes/_auth.analytics'
import { Route as AuthBillingRouteImport } from './routes/_auth.billing'
import { Route as AuthBranchRouteImport } from './routes/_auth.branch'
import { Route as AuthLanguagesRouteImport } from './routes/_auth.languages'
import { Route as AuthLoyaltyRouteImport } from './routes/_auth.loyalty'
import { Route as AuthMenuRouteImport } from './routes/_auth.menu'
import { Route as AuthMessagingRouteImport } from './routes/_auth.messaging'
import { Route as AuthNotificationsRouteImport } from './routes/_auth.notifications'
import { Route as AuthPromotionsRouteImport } from './routes/_auth.promotions'
import { Route as AuthQrRouteImport } from './routes/_auth.qr'
import { Route as AuthReservationsRouteImport } from './routes/_auth.reservations'
import { Route as AuthThemeRouteImport } from './routes/_auth.theme'
import { Route as AuthUsersRouteImport } from './routes/_auth.users'
import { Route as AuthBranchIndexRouteImport } from './routes/_auth.branch.index'
import { Route as AuthBranchGaleriaRouteImport } from './routes/_auth.branch.galeria'
import { Route as AuthBranchHorarioRouteImport } from './routes/_auth.branch.horario'
import { Route as AuthBranchLegalRouteImport } from './routes/_auth.branch.legal'
import { Route as AuthLanguagesIndexRouteImport } from './routes/_auth.languages.index'
import { Route as AuthLoyaltyIndexRouteImport } from './routes/_auth.loyalty.index'
import { Route as AuthLoyaltyInsightsRouteImport } from './routes/_auth.loyalty.insights'
import { Route as AuthLoyaltyProgramRouteImport } from './routes/_auth.loyalty.program'
import { Route as AuthMenuIndexRouteImport } from './routes/_auth.menu.index'
import { Route as AuthMenuCategoriesRouteImport } from './routes/_auth.menu.categories'
import { Route as AuthMenuDishesRouteImport } from './routes/_auth.menu.dishes'
import { Route as AuthMenuExtrasRouteImport } from './routes/_auth.menu.extras'
import { Route as AuthPromotionsIndexRouteImport } from './routes/_auth.promotions.index'
import { Route as AuthPromotionsPromotionIdRouteImport } from './routes/_auth.promotions.$promotionId'
import { Route as AuthPromotionsNewRouteImport } from './routes/_auth.promotions.new'
import { Route as AuthReservationsIndexRouteImport } from './routes/_auth.reservations.index'
import { Route as AuthReservationsClosuresRouteImport } from './routes/_auth.reservations.closures'
import { Route as AuthReservationsSettingsRouteImport } from './routes/_auth.reservations.settings'
import { Route as AuthMenuCategoriesIndexRouteImport } from './routes/_auth.menu.categories.index'
import { Route as AuthMenuCategoriesCategoryIdRouteImport } from './routes/_auth.menu.categories.$categoryId'
import { Route as AuthMenuCategoriesNewRouteImport } from './routes/_auth.menu.categories.new'
import { Route as AuthMenuDishesIndexRouteImport } from './routes/_auth.menu.dishes.index'
import { Route as AuthMenuDishesDishIdRouteImport } from './routes/_auth.menu.dishes.$dishId'
import { Route as AuthMenuDishesNewRouteImport } from './routes/_auth.menu.dishes.new'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectRestaurantRoute = SelectRestaurantRouteImport.update({
  id: '/select-restaurant',
  path: '/select-restaurant',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAnalyticsRoute = AuthAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingRoute = AuthBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBranchRoute = AuthBranchRouteImport.update({
  id: '/branch',
  path: '/branch',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLanguagesRoute = AuthLanguagesRouteImport.update({
  id: '/languages',
  path: '/languages',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoyaltyRoute = AuthLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMenuRoute = AuthMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMessagingRoute = AuthMessagingRouteImport.update({
  id: '/messaging',
  path: '/messaging',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNotificationsRoute = AuthNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromotionsRoute = AuthPromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQrRoute = AuthQrRouteImport.update({
  id: '/qr',
  path: '/qr',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReservationsRoute = AuthReservationsRouteImport.update({
  id: '/reservations',
  path: '/reservations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthThemeRoute = AuthThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersRoute = AuthUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBranchIndexRoute = AuthBranchIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthBranchRoute,
} as any)
const AuthBranchGaleriaRoute = AuthBranchGaleriaRouteImport.update({
  id: '/galeria',
  path: '/galeria',
  getParentRoute: () => AuthBranchRoute,
} as any)
const AuthBranchHorarioRoute = AuthBranchHorarioRouteImport.update({
  id: '/horario',
  path: '/horario',
  getParentRoute: () => AuthBranchRoute,
} as any)
const AuthBranchLegalRoute = AuthBranchLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => AuthBranchRoute,
} as any)
const AuthLanguagesIndexRoute = AuthLanguagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLanguagesRoute,
} as any)
const AuthLoyaltyIndexRoute = AuthLoyaltyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLoyaltyRoute,
} as any)
const AuthLoyaltyInsightsRoute = AuthLoyaltyInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AuthLoyaltyRoute,
} as any)
const AuthLoyaltyProgramRoute = AuthLoyaltyProgramRouteImport.update({
  id: '/program',
  path: '/program',
  getParentRoute: () => AuthLoyaltyRoute,
} as any)
const AuthMenuIndexRoute = AuthMenuIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMenuRoute,
} as any)
const AuthMenuCategoriesRoute = AuthMenuCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AuthMenuRoute,
} as any)
const AuthMenuDishesRoute = AuthMenuDishesRouteImport.update({
  id: '/dishes',
  path: '/dishes',
  getParentRoute: () => AuthMenuRoute,
} as any)
const AuthMenuExtrasRoute = AuthMenuExtrasRouteImport.update({
  id: '/extras',
  path: '/extras',
  getParentRoute: () => AuthMenuRoute,
} as any)
const AuthPromotionsIndexRoute = AuthPromotionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPromotionsRoute,
} as any)
const AuthPromotionsPromotionIdRoute =
  AuthPromotionsPromotionIdRouteImport.update({
    id: '/$promotionId',
    path: '/$promotionId',
    getParentRoute: () => AuthPromotionsRoute,
  } as any)
const AuthPromotionsNewRoute = AuthPromotionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthPromotionsRoute,
} as any)
const AuthReservationsIndexRoute = AuthReservationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthReservationsRoute,
} as any)
const AuthReservationsClosuresRoute =
  AuthReservationsClosuresRouteImport.update({
    id: '/closures',
    path: '/closures',
    getParentRoute: () => AuthReservationsRoute,
  } as any)
const AuthReservationsSettingsRoute =
  AuthReservationsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthReservationsRoute,
  } as any)
const AuthMenuCategoriesIndexRoute = AuthMenuCategoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMenuCategoriesRoute,
} as any)
const AuthMenuCategoriesCategoryIdRoute =
  AuthMenuCategoriesCategoryIdRouteImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => AuthMenuCategoriesRoute,
  } as any)
const AuthMenuCategoriesNewRoute = AuthMenuCategoriesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthMenuCategoriesRoute,
} as any)
const AuthMenuDishesIndexRoute = AuthMenuDishesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMenuDishesRoute,
} as any)
const AuthMenuDishesDishIdRoute = AuthMenuDishesDishIdRouteImport.update({
  id: '/$dishId',
  path: '/$dishId',
  getParentRoute: () => AuthMenuDishesRoute,
} as any)
const AuthMenuDishesNewRoute = AuthMenuDishesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthMenuDishesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/select-restaurant': typeof SelectRestaurantRoute
  '/analytics': typeof AuthAnalyticsRoute
  '/billing': typeof AuthBillingRoute
  '/branch': typeof AuthBranchRouteWithChildren
  '/languages': typeof AuthLanguagesRouteWithChildren
  '/loyalty': typeof AuthLoyaltyRouteWithChildren
  '/menu': typeof AuthMenuRouteWithChildren
  '/messaging': typeof AuthMessagingRoute
  '/notifications': typeof AuthNotificationsRoute
  '/promotions': typeof AuthPromotionsRouteWithChildren
  '/qr': typeof AuthQrRoute
  '/reservations': typeof AuthReservationsRouteWithChildren
  '/theme': typeof AuthThemeRoute
  '/users': typeof AuthUsersRoute
  '/branch/galeria': typeof AuthBranchGaleriaRoute
  '/branch/horario': typeof AuthBranchHorarioRoute
  '/branch/legal': typeof AuthBranchLegalRoute
  '/loyalty/insights': typeof AuthLoyaltyInsightsRoute
  '/loyalty/program': typeof AuthLoyaltyProgramRoute
  '/menu/categories': typeof AuthMenuCategoriesRouteWithChildren
  '/menu/dishes': typeof AuthMenuDishesRouteWithChildren
  '/menu/extras': typeof AuthMenuExtrasRoute
  '/promotions/$promotionId': typeof AuthPromotionsPromotionIdRoute
  '/promotions/new': typeof AuthPromotionsNewRoute
  '/reservations/closures': typeof AuthReservationsClosuresRoute
  '/reservations/settings': typeof AuthReservationsSettingsRoute
  '/branch/': typeof AuthBranchIndexRoute
  '/languages/': typeof AuthLanguagesIndexRoute
  '/loyalty/': typeof AuthLoyaltyIndexRoute
  '/menu/': typeof AuthMenuIndexRoute
  '/promotions/': typeof AuthPromotionsIndexRoute
  '/reservations/': typeof AuthReservationsIndexRoute
  '/menu/categories/$categoryId': typeof AuthMenuCategoriesCategoryIdRoute
  '/menu/categories/new': typeof AuthMenuCategoriesNewRoute
  '/menu/dishes/$dishId': typeof AuthMenuDishesDishIdRoute
  '/menu/dishes/new': typeof AuthMenuDishesNewRoute
  '/menu/categories/': typeof AuthMenuCategoriesIndexRoute
  '/menu/dishes/': typeof AuthMenuDishesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/select-restaurant': typeof SelectRestaurantRoute
  '/analytics': typeof AuthAnalyticsRoute
  '/billing': typeof AuthBillingRoute
  '/messaging': typeof AuthMessagingRoute
  '/notifications': typeof AuthNotificationsRoute
  '/qr': typeof AuthQrRoute
  '/theme': typeof AuthThemeRoute
  '/users': typeof AuthUsersRoute
  '/': typeof AuthIndexRoute
  '/branch/galeria': typeof AuthBranchGaleriaRoute
  '/branch/horario': typeof AuthBranchHorarioRoute
  '/branch/legal': typeof AuthBranchLegalRoute
  '/loyalty/insights': typeof AuthLoyaltyInsightsRoute
  '/loyalty/program': typeof AuthLoyaltyProgramRoute
  '/menu/extras': typeof AuthMenuExtrasRoute
  '/promotions/$promotionId': typeof AuthPromotionsPromotionIdRoute
  '/promotions/new': typeof AuthPromotionsNewRoute
  '/reservations/closures': typeof AuthReservationsClosuresRoute
  '/reservations/settings': typeof AuthReservationsSettingsRoute
  '/branch': typeof AuthBranchIndexRoute
  '/languages': typeof AuthLanguagesIndexRoute
  '/loyalty': typeof AuthLoyaltyIndexRoute
  '/menu': typeof AuthMenuIndexRoute
  '/promotions': typeof AuthPromotionsIndexRoute
  '/reservations': typeof AuthReservationsIndexRoute
  '/menu/categories/$categoryId': typeof AuthMenuCategoriesCategoryIdRoute
  '/menu/categories/new': typeof AuthMenuCategoriesNewRoute
  '/menu/dishes/$dishId': typeof AuthMenuDishesDishIdRoute
  '/menu/dishes/new': typeof AuthMenuDishesNewRoute
  '/menu/categories': typeof AuthMenuCategoriesIndexRoute
  '/menu/dishes': typeof AuthMenuDishesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/select-restaurant': typeof SelectRestaurantRoute
  '/_auth/analytics': typeof AuthAnalyticsRoute
  '/_auth/billing': typeof AuthBillingRoute
  '/_auth/branch': typeof AuthBranchRouteWithChildren
  '/_auth/languages': typeof AuthLanguagesRouteWithChildren
  '/_auth/loyalty': typeof AuthLoyaltyRouteWithChildren
  '/_auth/menu': typeof AuthMenuRouteWithChildren
  '/_auth/messaging': typeof AuthMessagingRoute
  '/_auth/notifications': typeof AuthNotificationsRoute
  '/_auth/promotions': typeof AuthPromotionsRouteWithChildren
  '/_auth/qr': typeof AuthQrRoute
  '/_auth/reservations': typeof AuthReservationsRouteWithChildren
  '/_auth/theme': typeof AuthThemeRoute
  '/_auth/users': typeof AuthUsersRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/branch/galeria': typeof AuthBranchGaleriaRoute
  '/_auth/branch/horario': typeof AuthBranchHorarioRoute
  '/_auth/branch/legal': typeof AuthBranchLegalRoute
  '/_auth/loyalty/insights': typeof AuthLoyaltyInsightsRoute
  '/_auth/loyalty/program': typeof AuthLoyaltyProgramRoute
  '/_auth/menu/categories': typeof AuthMenuCategoriesRouteWithChildren
  '/_auth/menu/dishes': typeof AuthMenuDishesRouteWithChildren
  '/_auth/menu/extras': typeof AuthMenuExtrasRoute
  '/_auth/promotions/$promotionId': typeof AuthPromotionsPromotionIdRoute
  '/_auth/promotions/new': typeof AuthPromotionsNewRoute
  '/_auth/reservations/closures': typeof AuthReservationsClosuresRoute
  '/_auth/reservations/settings': typeof AuthReservationsSettingsRoute
  '/_auth/branch/': typeof AuthBranchIndexRoute
  '/_auth/languages/': typeof AuthLanguagesIndexRoute
  '/_auth/loyalty/': typeof AuthLoyaltyIndexRoute
  '/_auth/menu/': typeof AuthMenuIndexRoute
  '/_auth/promotions/': typeof AuthPromotionsIndexRoute
  '/_auth/reservations/': typeof AuthReservationsIndexRoute
  '/_auth/menu/categories/$categoryId': typeof AuthMenuCategoriesCategoryIdRoute
  '/_auth/menu/categories/new': typeof AuthMenuCategoriesNewRoute
  '/_auth/menu/dishes/$dishId': typeof AuthMenuDishesDishIdRoute
  '/_auth/menu/dishes/new': typeof AuthMenuDishesNewRoute
  '/_auth/menu/categories/': typeof AuthMenuCategoriesIndexRoute
  '/_auth/menu/dishes/': typeof AuthMenuDishesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/select-restaurant'
    | '/analytics'
    | '/billing'
    | '/branch'
    | '/languages'
    | '/loyalty'
    | '/menu'
    | '/messaging'
    | '/notifications'
    | '/promotions'
    | '/qr'
    | '/reservations'
    | '/theme'
    | '/users'
    | '/branch/galeria'
    | '/branch/horario'
    | '/branch/legal'
    | '/loyalty/insights'
    | '/loyalty/program'
    | '/menu/categories'
    | '/menu/dishes'
    | '/menu/extras'
    | '/promotions/$promotionId'
    | '/promotions/new'
    | '/reservations/closures'
    | '/reservations/settings'
    | '/branch/'
    | '/languages/'
    | '/loyalty/'
    | '/menu/'
    | '/promotions/'
    | '/reservations/'
    | '/menu/categories/$categoryId'
    | '/menu/categories/new'
    | '/menu/dishes/$dishId'
    | '/menu/dishes/new'
    | '/menu/categories/'
    | '/menu/dishes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/select-restaurant'
    | '/analytics'
    | '/billing'
    | '/messaging'
    | '/notifications'
    | '/qr'
    | '/theme'
    | '/users'
    | '/'
    | '/branch/galeria'
    | '/branch/horario'
    | '/branch/legal'
    | '/loyalty/insights'
    | '/loyalty/program'
    | '/menu/extras'
    | '/promotions/$promotionId'
    | '/promotions/new'
    | '/reservations/closures'
    | '/reservations/settings'
    | '/branch'
    | '/languages'
    | '/loyalty'
    | '/menu'
    | '/promotions'
    | '/reservations'
    | '/menu/categories/$categoryId'
    | '/menu/categories/new'
    | '/menu/dishes/$dishId'
    | '/menu/dishes/new'
    | '/menu/categories'
    | '/menu/dishes'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/select-restaurant'
    | '/_auth/analytics'
    | '/_auth/billing'
    | '/_auth/branch'
    | '/_auth/languages'
    | '/_auth/loyalty'
    | '/_auth/menu'
    | '/_auth/messaging'
    | '/_auth/notifications'
    | '/_auth/promotions'
    | '/_auth/qr'
    | '/_auth/reservations'
    | '/_auth/theme'
    | '/_auth/users'
    | '/_auth/'
    | '/_auth/branch/galeria'
    | '/_auth/branch/horario'
    | '/_auth/branch/legal'
    | '/_auth/loyalty/insights'
    | '/_auth/loyalty/program'
    | '/_auth/menu/categories'
    | '/_auth/menu/dishes'
    | '/_auth/menu/extras'
    | '/_auth/promotions/$promotionId'
    | '/_auth/promotions/new'
    | '/_auth/reservations/closures'
    | '/_auth/reservations/settings'
    | '/_auth/branch/'
    | '/_auth/languages/'
    | '/_auth/loyalty/'
    | '/_auth/menu/'
    | '/_auth/promotions/'
    | '/_auth/reservations/'
    | '/_auth/menu/categories/$categoryId'
    | '/_auth/menu/categories/new'
    | '/_auth/menu/dishes/$dishId'
    | '/_auth/menu/dishes/new'
    | '/_auth/menu/categories/'
    | '/_auth/menu/dishes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  SelectRestaurantRoute: typeof SelectRestaurantRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-restaurant': {
      id: '/select-restaurant'
      path: '/select-restaurant'
      fullPath: '/select-restaurant'
      preLoaderRoute: typeof SelectRestaurantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/analytics': {
      id: '/_auth/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthAnalyticsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing': {
      id: '/_auth/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/branch': {
      id: '/_auth/branch'
      path: '/branch'
      fullPath: '/branch'
      preLoaderRoute: typeof AuthBranchRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/languages': {
      id: '/_auth/languages'
      path: '/languages'
      fullPath: '/languages'
      preLoaderRoute: typeof AuthLanguagesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/loyalty': {
      id: '/_auth/loyalty'
      path: '/loyalty'
      fullPath: '/loyalty'
      preLoaderRoute: typeof AuthLoyaltyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/menu': {
      id: '/_auth/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof AuthMenuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/messaging': {
      id: '/_auth/messaging'
      path: '/messaging'
      fullPath: '/messaging'
      preLoaderRoute: typeof AuthMessagingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/notifications': {
      id: '/_auth/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthNotificationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotions': {
      id: '/_auth/promotions'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof AuthPromotionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/qr': {
      id: '/_auth/qr'
      path: '/qr'
      fullPath: '/qr'
      preLoaderRoute: typeof AuthQrRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reservations': {
      id: '/_auth/reservations'
      path: '/reservations'
      fullPath: '/reservations'
      preLoaderRoute: typeof AuthReservationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/theme': {
      id: '/_auth/theme'
      path: '/theme'
      fullPath: '/theme'
      preLoaderRoute: typeof AuthThemeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users': {
      id: '/_auth/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/branch/': {
      id: '/_auth/branch/'
      path: '/'
      fullPath: '/branch/'
      preLoaderRoute: typeof AuthBranchIndexRouteImport
      parentRoute: typeof AuthBranchRoute
    }
    '/_auth/branch/galeria': {
      id: '/_auth/branch/galeria'
      path: '/galeria'
      fullPath: '/branch/galeria'
      preLoaderRoute: typeof AuthBranchGaleriaRouteImport
      parentRoute: typeof AuthBranchRoute
    }
    '/_auth/branch/horario': {
      id: '/_auth/branch/horario'
      path: '/horario'
      fullPath: '/branch/horario'
      preLoaderRoute: typeof AuthBranchHorarioRouteImport
      parentRoute: typeof AuthBranchRoute
    }
    '/_auth/branch/legal': {
      id: '/_auth/branch/legal'
      path: '/legal'
      fullPath: '/branch/legal'
      preLoaderRoute: typeof AuthBranchLegalRouteImport
      parentRoute: typeof AuthBranchRoute
    }
    '/_auth/languages/': {
      id: '/_auth/languages/'
      path: '/'
      fullPath: '/languages/'
      preLoaderRoute: typeof AuthLanguagesIndexRouteImport
      parentRoute: typeof AuthLanguagesRoute
    }
    '/_auth/loyalty/': {
      id: '/_auth/loyalty/'
      path: '/'
      fullPath: '/loyalty/'
      preLoaderRoute: typeof AuthLoyaltyIndexRouteImport
      parentRoute: typeof AuthLoyaltyRoute
    }
    '/_auth/loyalty/insights': {
      id: '/_auth/loyalty/insights'
      path: '/insights'
      fullPath: '/loyalty/insights'
      preLoaderRoute: typeof AuthLoyaltyInsightsRouteImport
      parentRoute: typeof AuthLoyaltyRoute
    }
    '/_auth/loyalty/program': {
      id: '/_auth/loyalty/program'
      path: '/program'
      fullPath: '/loyalty/program'
      preLoaderRoute: typeof AuthLoyaltyProgramRouteImport
      parentRoute: typeof AuthLoyaltyRoute
    }
    '/_auth/menu/': {
      id: '/_auth/menu/'
      path: '/'
      fullPath: '/menu/'
      preLoaderRoute: typeof AuthMenuIndexRouteImport
      parentRoute: typeof AuthMenuRoute
    }
    '/_auth/menu/categories': {
      id: '/_auth/menu/categories'
      path: '/categories'
      fullPath: '/menu/categories'
      preLoaderRoute: typeof AuthMenuCategoriesRouteImport
      parentRoute: typeof AuthMenuRoute
    }
    '/_auth/menu/dishes': {
      id: '/_auth/menu/dishes'
      path: '/dishes'
      fullPath: '/menu/dishes'
      preLoaderRoute: typeof AuthMenuDishesRouteImport
      parentRoute: typeof AuthMenuRoute
    }
    '/_auth/menu/extras': {
      id: '/_auth/menu/extras'
      path: '/extras'
      fullPath: '/menu/extras'
      preLoaderRoute: typeof AuthMenuExtrasRouteImport
      parentRoute: typeof AuthMenuRoute
    }
    '/_auth/promotions/': {
      id: '/_auth/promotions/'
      path: '/'
      fullPath: '/promotions/'
      preLoaderRoute: typeof AuthPromotionsIndexRouteImport
      parentRoute: typeof AuthPromotionsRoute
    }
    '/_auth/promotions/$promotionId': {
      id: '/_auth/promotions/$promotionId'
      path: '/$promotionId'
      fullPath: '/promotions/$promotionId'
      preLoaderRoute: typeof AuthPromotionsPromotionIdRouteImport
      parentRoute: typeof AuthPromotionsRoute
    }
    '/_auth/promotions/new': {
      id: '/_auth/promotions/new'
      path: '/new'
      fullPath: '/promotions/new'
      preLoaderRoute: typeof AuthPromotionsNewRouteImport
      parentRoute: typeof AuthPromotionsRoute
    }
    '/_auth/reservations/': {
      id: '/_auth/reservations/'
      path: '/'
      fullPath: '/reservations/'
      preLoaderRoute: typeof AuthReservationsIndexRouteImport
      parentRoute: typeof AuthReservationsRoute
    }
    '/_auth/reservations/closures': {
      id: '/_auth/reservations/closures'
      path: '/closures'
      fullPath: '/reservations/closures'
      preLoaderRoute: typeof AuthReservationsClosuresRouteImport
      parentRoute: typeof AuthReservationsRoute
    }
    '/_auth/reservations/settings': {
      id: '/_auth/reservations/settings'
      path: '/settings'
      fullPath: '/reservations/settings'
      preLoaderRoute: typeof AuthReservationsSettingsRouteImport
      parentRoute: typeof AuthReservationsRoute
    }
    '/_auth/menu/categories/': {
      id: '/_auth/menu/categories/'
      path: '/'
      fullPath: '/menu/categories/'
      preLoaderRoute: typeof AuthMenuCategoriesIndexRouteImport
      parentRoute: typeof AuthMenuCategoriesRoute
    }
    '/_auth/menu/categories/$categoryId': {
      id: '/_auth/menu/categories/$categoryId'
      path: '/$categoryId'
      fullPath: '/menu/categories/$categoryId'
      preLoaderRoute: typeof AuthMenuCategoriesCategoryIdRouteImport
      parentRoute: typeof AuthMenuCategoriesRoute
    }
    '/_auth/menu/categories/new': {
      id: '/_auth/menu/categories/new'
      path: '/new'
      fullPath: '/menu/categories/new'
      preLoaderRoute: typeof AuthMenuCategoriesNewRouteImport
      parentRoute: typeof AuthMenuCategoriesRoute
    }
    '/_auth/menu/dishes/': {
      id: '/_auth/menu/dishes/'
      path: '/'
      fullPath: '/menu/dishes/'
      preLoaderRoute: typeof AuthMenuDishesIndexRouteImport
      parentRoute: typeof AuthMenuDishesRoute
    }
    '/_auth/menu/dishes/$dishId': {
      id: '/_auth/menu/dishes/$dishId'
      path: '/$dishId'
      fullPath: '/menu/dishes/$dishId'
      preLoaderRoute: typeof AuthMenuDishesDishIdRouteImport
      parentRoute: typeof AuthMenuDishesRoute
    }
    '/_auth/menu/dishes/new': {
      id: '/_auth/menu/dishes/new'
      path: '/new'
      fullPath: '/menu/dishes/new'
      preLoaderRoute: typeof AuthMenuDishesNewRouteImport
      parentRoute: typeof AuthMenuDishesRoute
    }
  }
}

interface AuthBranchRouteChildren {
  AuthBranchGaleriaRoute: typeof AuthBranchGaleriaRoute
  AuthBranchHorarioRoute: typeof AuthBranchHorarioRoute
  AuthBranchLegalRoute: typeof AuthBranchLegalRoute
  AuthBranchIndexRoute: typeof AuthBranchIndexRoute
}

const AuthBranchRouteChildren: AuthBranchRouteChildren = {
  AuthBranchGaleriaRoute: AuthBranchGaleriaRoute,
  AuthBranchHorarioRoute: AuthBranchHorarioRoute,
  AuthBranchLegalRoute: AuthBranchLegalRoute,
  AuthBranchIndexRoute: AuthBranchIndexRoute,
}

const AuthBranchRouteWithChildren = AuthBranchRoute._addFileChildren(
  AuthBranchRouteChildren,
)

interface AuthLanguagesRouteChildren {
  AuthLanguagesIndexRoute: typeof AuthLanguagesIndexRoute
}

const AuthLanguagesRouteChildren: AuthLanguagesRouteChildren = {
  AuthLanguagesIndexRoute: AuthLanguagesIndexRoute,
}

const AuthLanguagesRouteWithChildren = AuthLanguagesRoute._addFileChildren(
  AuthLanguagesRouteChildren,
)

interface AuthLoyaltyRouteChildren {
  AuthLoyaltyInsightsRoute: typeof AuthLoyaltyInsightsRoute
  AuthLoyaltyProgramRoute: typeof AuthLoyaltyProgramRoute
  AuthLoyaltyIndexRoute: typeof AuthLoyaltyIndexRoute
}

const AuthLoyaltyRouteChildren: AuthLoyaltyRouteChildren = {
  AuthLoyaltyInsightsRoute: AuthLoyaltyInsightsRoute,
  AuthLoyaltyProgramRoute: AuthLoyaltyProgramRoute,
  AuthLoyaltyIndexRoute: AuthLoyaltyIndexRoute,
}

const AuthLoyaltyRouteWithChildren = AuthLoyaltyRoute._addFileChildren(
  AuthLoyaltyRouteChildren,
)

interface AuthMenuCategoriesRouteChildren {
  AuthMenuCategoriesCategoryIdRoute: typeof AuthMenuCategoriesCategoryIdRoute
  AuthMenuCategoriesNewRoute: typeof AuthMenuCategoriesNewRoute
  AuthMenuCategoriesIndexRoute: typeof AuthMenuCategoriesIndexRoute
}

const AuthMenuCategoriesRouteChildren: AuthMenuCategoriesRouteChildren = {
  AuthMenuCategoriesCategoryIdRoute: AuthMenuCategoriesCategoryIdRoute,
  AuthMenuCategoriesNewRoute: AuthMenuCategoriesNewRoute,
  AuthMenuCategoriesIndexRoute: AuthMenuCategoriesIndexRoute,
}

const AuthMenuCategoriesRouteWithChildren =
  AuthMenuCategoriesRoute._addFileChildren(AuthMenuCategoriesRouteChildren)

interface AuthMenuDishesRouteChildren {
  AuthMenuDishesDishIdRoute: typeof AuthMenuDishesDishIdRoute
  AuthMenuDishesNewRoute: typeof AuthMenuDishesNewRoute
  AuthMenuDishesIndexRoute: typeof AuthMenuDishesIndexRoute
}

const AuthMenuDishesRouteChildren: AuthMenuDishesRouteChildren = {
  AuthMenuDishesDishIdRoute: AuthMenuDishesDishIdRoute,
  AuthMenuDishesNewRoute: AuthMenuDishesNewRoute,
  AuthMenuDishesIndexRoute: AuthMenuDishesIndexRoute,
}

const AuthMenuDishesRouteWithChildren = AuthMenuDishesRoute._addFileChildren(
  AuthMenuDishesRouteChildren,
)

interface AuthMenuRouteChildren {
  AuthMenuCategoriesRoute: typeof AuthMenuCategoriesRouteWithChildren
  AuthMenuDishesRoute: typeof AuthMenuDishesRouteWithChildren
  AuthMenuExtrasRoute: typeof AuthMenuExtrasRoute
  AuthMenuIndexRoute: typeof AuthMenuIndexRoute
}

const AuthMenuRouteChildren: AuthMenuRouteChildren = {
  AuthMenuCategoriesRoute: AuthMenuCategoriesRouteWithChildren,
  AuthMenuDishesRoute: AuthMenuDishesRouteWithChildren,
  AuthMenuExtrasRoute: AuthMenuExtrasRoute,
  AuthMenuIndexRoute: AuthMenuIndexRoute,
}

const AuthMenuRouteWithChildren = AuthMenuRoute._addFileChildren(
  AuthMenuRouteChildren,
)

interface AuthPromotionsRouteChildren {
  AuthPromotionsPromotionIdRoute: typeof AuthPromotionsPromotionIdRoute
  AuthPromotionsNewRoute: typeof AuthPromotionsNewRoute
  AuthPromotionsIndexRoute: typeof AuthPromotionsIndexRoute
}

const AuthPromotionsRouteChildren: AuthPromotionsRouteChildren = {
  AuthPromotionsPromotionIdRoute: AuthPromotionsPromotionIdRoute,
  AuthPromotionsNewRoute: AuthPromotionsNewRoute,
  AuthPromotionsIndexRoute: AuthPromotionsIndexRoute,
}

const AuthPromotionsRouteWithChildren = AuthPromotionsRoute._addFileChildren(
  AuthPromotionsRouteChildren,
)

interface AuthReservationsRouteChildren {
  AuthReservationsClosuresRoute: typeof AuthReservationsClosuresRoute
  AuthReservationsSettingsRoute: typeof AuthReservationsSettingsRoute
  AuthReservationsIndexRoute: typeof AuthReservationsIndexRoute
}

const AuthReservationsRouteChildren: AuthReservationsRouteChildren = {
  AuthReservationsClosuresRoute: AuthReservationsClosuresRoute,
  AuthReservationsSettingsRoute: AuthReservationsSettingsRoute,
  AuthReservationsIndexRoute: AuthReservationsIndexRoute,
}

const AuthReservationsRouteWithChildren =
  AuthReservationsRoute._addFileChildren(AuthReservationsRouteChildren)

interface AuthRouteChildren {
  AuthAnalyticsRoute: typeof AuthAnalyticsRoute
  AuthBillingRoute: typeof AuthBillingRoute
  AuthBranchRoute: typeof AuthBranchRouteWithChildren
  AuthLanguagesRoute: typeof AuthLanguagesRouteWithChildren
  AuthLoyaltyRoute: typeof AuthLoyaltyRouteWithChildren
  AuthMenuRoute: typeof AuthMenuRouteWithChildren
  AuthMessagingRoute: typeof AuthMessagingRoute
  AuthNotificationsRoute: typeof AuthNotificationsRoute
  AuthPromotionsRoute: typeof AuthPromotionsRouteWithChildren
  AuthQrRoute: typeof AuthQrRoute
  AuthReservationsRoute: typeof AuthReservationsRouteWithChildren
  AuthThemeRoute: typeof AuthThemeRoute
  AuthUsersRoute: typeof AuthUsersRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAnalyticsRoute: AuthAnalyticsRoute,
  AuthBillingRoute: AuthBillingRoute,
  AuthBranchRoute: AuthBranchRouteWithChildren,
  AuthLanguagesRoute: AuthLanguagesRouteWithChildren,
  AuthLoyaltyRoute: AuthLoyaltyRouteWithChildren,
  AuthMenuRoute: AuthMenuRouteWithChildren,
  AuthMessagingRoute: AuthMessagingRoute,
  AuthNotificationsRoute: AuthNotificationsRoute,
  AuthPromotionsRoute: AuthPromotionsRouteWithChildren,
  AuthQrRoute: AuthQrRoute,
  AuthReservationsRoute: AuthReservationsRouteWithChildren,
  AuthThemeRoute: AuthThemeRoute,
  AuthUsersRoute: AuthUsersRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  SelectRestaurantRoute: SelectRestaurantRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
